<div class="popupu_card pc_wo_bg pop_active_card" *ngIf="show">

  <div class="popup_inner pci_pad_inner">

      <a href="javascript:void(0)" (click)="CloseGoogleMapCustomer()" class="pc_close_btn checkingfortest"><i class="icon-close"></i></a>

      <div class="ppi_grid_card">
          
          <div class="pgc_title">
            <!-- <ng-container *ngFor="let obj of topbusinessList; let k = index;"> -->

              <div class="dc_checkin_card">

                <div class="dcc_show_card">

                  <div class="dcc_card dc_white_bg">

                    <div class="dcc_cont_area">
                        
                      <h2>{{this.googlemapstate.customername}}</h2>
                      <p>{{this.googlemapstate.meetingaddress1}}</p>

                      <div class="dcca_icon_area"></div>

                    </div>

                  </div>

                </div>

              </div>    
              
            <!-- </ng-container> -->
          </div>
            
          <div class="dc_checkin_card" *ngIf="bootombusinessList.length > 0">

            <div class="dcc_show_card">

              <ng-container *ngFor="let obj of bootombusinessList; let k = index;">
                <div class="dcc_card dc_grid_card">
              
                  <div class="dgc_radio">
                  
                    <input type="radio" group="googleLinkradio_RadioList"
                    id="div_googleLinkradio_RadioList_{{obj.customer_id}}"
                    name="googleLinkradio_RadioList"
                    [(ngModel)]="googlemapstate.MapCustomerID.value"
                    [value]="obj"
                    value="{{obj.customer_id}}">
                  
                  </div>
                
                  <div class="dcc_cont_area">
                
                    <div class="dtc_edit_card">
                      <h2> {{obj.customer_name}}                      
                      </h2>
                    </div>
                    
                    <p>{{getAddress(obj)}}</p>
                    
                    <div class="dcca_icon_area ng-star-inserted">
                      <div class="dccia_right"><a href="javascript:void(0)"><i class="icon-location_icon"></i> <span class="dcr_warp_txt">{{obj.display_roundoff_distance_in_km}}</span></a></div>
                    </div>
                
                  </div>
                  
                </div>
              </ng-container>

            </div>

          </div>

      </div>
      
      <app-NoContent [msg]="'No data found'" *ngIf="bootombusinessList.length == 0 && googleLinkClicked"></app-NoContent> 

     

      <div class="pgc_btn" *ngIf="googleLinkClicked">    
              
        <ng-container *ngIf="bootombusinessList.length == 0">
          <button (click)="addGoogleCustomer()">ADD</button>
        </ng-container>
        <ng-container *ngIf="bootombusinessList.length > 0">        
          <button (click)="googleMappingYesNo()">LINK {{bootombusinessList[0].displayCategoryName}}</button>
        </ng-container>

      </div>

  </div>

</div> 

<div class="popupu_card ci_popup_card pop_active_card" *ngIf="mappingConfirmationshow">

  <div class="popup_inner">
      
      <div class="ci_popup_txt_area">

        <p class="cpta_img"><img src="assets/images/alert_icon.svg" alt=""></p>
            
        <h2>Alert!</h2>

          <h1>Make sure you are linking the right school. This choice cannot be modified later.</h1>
      </div>

      <div class="ci_popup_btn_area">

          <button (click)="googleMappingCancel()">CANCEL</button>

          <button (click)="googleMappingYes()">SUBMIT</button>

      </div>

  </div>

</div> 